import React, {useState} from 'react';
import {showErrorMessage} from "@/common/components/ErrorMessage";
import {getPlatform} from "@/hooks";
import {useTranslation} from "react-i18next";

const desktop_base_class = 'm2g-order-confirmation-payment';
const mobile_base_class = 'm2g-order-confirmation-footer';

const {
    _class: {
        Common: { Price },
    },
} = Mobi2Go;

const BalanceSpender = ({balance}) => {
    const [t] = useTranslation('order.balances');
    const [isFetching, setIsFetching] = useState(false);
    const [checkedState, setCheckedState] = useState(false);

    // Placeholder functions for testing, to be removed once web api is completed
    // -----------------------------------------------------------------------
    const claimRebate = (balanceKey) => {
        console.log(balanceKey)
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                if (false) { // change this to true to test error handling
                    reject('test error')
                } else {
                    resolve()
                }
            }, 3000)
        })
    }

    const revokeClaimedRebate = (balanceKey) => {
        console.log(balanceKey)
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                if (false) { // change this to true to test error handling
                    reject('test error')
                } else {
                    resolve()
                }
            }, 3000)
        })
    }
    // -----------------------------------------------------------------------

    const {
        key,
        name,
        amount
    } = balance;

    //this to format the amount to price
    const pricedAmount = new Price(amount);

    const handleCheckboxClick = async (e) => {
        e.preventDefault()

        if (isFetching) { // fail safe to prevent multiple calls
            return;
        }

        setIsFetching(true);

        try {
            if (!checkedState) {
                await claimRebate(key);
            } else {
                await revokeClaimedRebate(key);
            }
            setCheckedState(!checkedState)
        } catch (e) {
            showErrorMessage('Error', 'Something went wrong claiming balance');
            console.log(e);
        } finally {
            setIsFetching(false);
        }
    }


    if (getPlatform() === 'web') {
        return (
            <div
                className="m2g-order-confirmation-payment-method m2g-order-confirmation-payment-credit"
                data-checked={checkedState}
                aria-checked={checkedState}
                aria-disabled={isFetching}
                onClick={e => handleCheckboxClick(e)}
                id={`customer-balance-${name}`}
            >
                {isFetching ? // if fetching display loading spinner in place of checkbox
                    <div
                        className={`${mobile_base_class}__loading-spinner m2g-icon m2g-icon--spinner m2g-list-cell__icon`}
                    />
                    :
                    <div
                        className={`${desktop_base_class}-credit-checkbox m2g-icon m2g-icon--checkbox m2g-icon--tick`}
                    />
                }
                <label
                    className={`${desktop_base_class}-credit-label`}
                >
                    {name}
                </label>

                <div
                    className={`${desktop_base_class}-credit-value`}
                >
                    <span className="m2g-text--small m2g-text--offset">
                       {t('order.balances:price', {price: pricedAmount})}

                        {t('available_balance')}
                    </span>
                </div>

            </div>
        )
    } else {
        return (
            <div
                className={`${mobile_base_class}-credit m2g-list-cell m2g-touchable`}
                data-checked={checkedState}
                aria-checked={checkedState}
                aria-disabled={isFetching}
                onClick={e => handleCheckboxClick(e)}
                id={`customer-balance-${name}`}

            >
                {isFetching ?
                    <div
                        className={`${mobile_base_class}__loading-spinner m2g-icon m2g-icon--spinner m2g-list-cell__icon`}
                    />
                    :
                    <div
                        className="m2g-list-cell__icon m2g-icon m2g-icon--checkbox m2g-icon--tick"
                    />
                }
                <div
                    className={`${mobile_base_class}-credit-content m2g-list-cell__content m2g-list-cell__content--small`}
                >
                    <div
                        className={`${mobile_base_class}-credit-label`}
                    >
                        {name}
                    </div>
                    <div
                        className={`${mobile_base_class}-credit-value`}
                    >
                        {t('order.balances:price', {price: pricedAmount})}

                        {t('available_balance')}
                    </div>
                </div>
            </div>
        )
    }
}


export default BalanceSpender;
